import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { positionTooltip, positionTooltipOverlay } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export var Tooltip = function Tooltip(_ref) {
  var _cx;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      dense = _ref.dense,
      open = _ref.open,
      orientation = _ref.orientation,
      overlay = _ref.overlay,
      tooltipRef = _ref.tooltipRef,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["align", "children", "className", "dense", "open", "orientation", "overlay", "tooltipRef", "width"]);

  var fallbackRef = useRef(null);
  var ref = tooltipRef || fallbackRef;
  useEffect(function () {
    var setTooltipPosition = function setTooltipPosition() {
      if (overlay) {
        // width eval corresponds with vanilla fullWidth arg in getTooltipModifiers
        if (ref.current) positionTooltipOverlay(ref.current, align, orientation, width === 'full');
      } else {
        if (ref.current) positionTooltip(ref.current);
      }
    };

    setTooltipPosition();
    if (overlay) window.addEventListener('scroll', setTooltipPosition);
    window.addEventListener('resize', setTooltipPosition);
    return function () {
      window.removeEventListener('scroll', setTooltipPosition);
      window.removeEventListener('resize', setTooltipPosition);
    };
  }, [ref, align, orientation, overlay, open, width]);
  return React.createElement("div", _objectSpread({
    className: cx('tds-tooltip', (_cx = {}, _defineProperty(_cx, "tds-tooltip--orientation-".concat(orientation), orientation), _defineProperty(_cx, "tds-tooltip--width-".concat(width), width), _defineProperty(_cx, "tds-tooltip--align-".concat(align), align), _defineProperty(_cx, 'tds-tooltip--overlay', overlay), _defineProperty(_cx, 'tds-density--dense', dense), _defineProperty(_cx, 'tds-tooltip--open', open), _defineProperty(_cx, 'tds-tooltip--closed', open === false), _cx), className),
    ref: ref,
    role: "tooltip"
  }, rest), children);
};